<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="客户账单编号" prop="custStatementNo">
            <el-input
              clearable
              v-model="formData.custStatementNo"
              placeholder="请输入客户账单编号"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="客户名称" prop="custName">
            <el-input
              clearable
              v-model="formData.custName"
              placeholder="请输入客户名称"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="账单结束日期" prop="endDate">
            <el-input
              clearable
              v-model="formData.endDate"
              placeholder="请输入账单结束日期"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="生成时间" prop="builderTime">
            <el-input
              v-model="formData.builderTime"
              placeholder="请选择生成时间"
              default
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="应收运费合计" prop="incomeAmount">
            <el-input
              v-model="formData.incomeAmount"
              placeholder="请输入应收运费合计"
              default
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="应收费用合计" prop="incomeCostAmount">
            <el-input
              v-model="formData.incomeCostAmount"
              placeholder="请输入应收费用合计"
              default
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="应收合计" prop="incomeTotalAmount">
            <el-input
              v-model="formData.incomeTotalAmount"
              placeholder="请输入应收合计"
              default
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="账单说明" prop="remark">
            <el-input
              v-model="formData.remark"
              placeholder="请输入账单说明"
              default
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="账单开始日期" prop="beginDate">
            <el-input
              clearable
              v-model="formData.beginDate"
              placeholder="请输入账单开始日期"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item label="账单状态" prop="custStatementStatus">
            <el-radio-group v-model="formData.custStatementStatus">
              <el-radio label="Y">已收款</el-radio>
              <el-radio label="N">新增</el-radio>
              <el-radio label="P">已开票</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    custStatementCode: String,
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { custStatementStatus: 'Y' },
      rules: {
        alarmRuleName: [
          { required: true, message: '请输入预警规则名称', trigger: 'blur' },
        ],
        sendType: [
          { required: true, message: '请选择推送方式', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.custStatementCode) return
      this.$api
        .finCustomerStatementDetailApi({
          custStatementCode: this.custStatementCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .sysAlarmRuleSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
